
export enum AuthenticationAction {
    REQUIRES_PASSWORD = "REQUIRES_PASSWORD",
    AUTHENTICATION_COMPLETE = "AUTHENTICATION_COMPLETE",
    REQUIRES_ACTIVATION_CODE = "REQUIRES_ACTIVATION_CODE",
    CREATE_PASSWORD = "CREATE_PASSWORD",
}

export type RequiresPasswordResult = Readonly<{
    type: string
    action: AuthenticationAction.REQUIRES_PASSWORD
    message?: string
}>

export type AuthenticationCompleteResult = Readonly<{
    type: string
    action: AuthenticationAction.AUTHENTICATION_COMPLETE,
    message?: string
}>

export type RequiresActivationCodeResult = Readonly<{
    type: string
    action: AuthenticationAction.REQUIRES_ACTIVATION_CODE,
    message?: string
}>

export type CreatePasswordResult = Readonly<{
    type: string
    action: AuthenticationAction.CREATE_PASSWORD,
    message?: string
}>

export type Authentication = Readonly<{
    type: string
    token: string
}>


// TODO use this as the user you get when logging in
export type AuthenticationUser = Readonly<{
    companyId: number
    id: number
    uid: string
    username: string
    userGroupId?: number
    displayInitials: string
    userTypeId: 10,
    userType: UserType

}>

export type User = Readonly<{
    companyId: number
    id: number
    uid: string
    username: string
    userGroupId?: number
    displayInitials: string
    userTypeId: 10,
    userType: UserType
}>


export enum UserType {
    SYSTEM_OWNER = "SYSTEM_OWNER",
    SUPPORT = "SUPPORT",
    MERCHANT = "MERCHANT",
    COMPANY = "COMPANY",
    DEBTOR = "DEBTOR",
    USER = "USER",
    SERVICE_CENTER = "SERVICE_CENTER",
    SATELLITE_CANTEEN = "SATELLITE_CANTEEN",
    SUPPLIER = "SUPPLIER",
    OFFICE_MANAGER = "OFFICE_MANAGER",
}

export type RequiresPasswordResponse = Readonly<{
    authentication: Authentication
    authenticationResult: RequiresPasswordResult
}>


export type RequiresActivationCodeResponse = Readonly<{
    authentication: Authentication
    authenticationResult: RequiresActivationCodeResult
}>

export type RequiresCreatePasswordResponse = Readonly<{
    authentication: Authentication
    authenticationResult: CreatePasswordResult
}>


export function isRequiresPasswordResponse(response: AuthenticationResponse): response is RequiresPasswordResponse {
    return response.authenticationResult.action === AuthenticationAction.REQUIRES_PASSWORD
}

export function isRequiresActivationCodeResponse(response: AuthenticationResponse): response is RequiresPasswordResponse {
    return response.authenticationResult.action === AuthenticationAction.REQUIRES_ACTIVATION_CODE
}

export function isRequiresCreatePasswordResponse(response: AuthenticationResponse): response is RequiresCreatePasswordResponse {
    return response.authenticationResult.action === AuthenticationAction.CREATE_PASSWORD
}

export type AuthenticationCompleteResponse = Readonly<{
    authenticationResult: AuthenticationCompleteResult
    authentication: Authentication
    user: AuthenticationUser
}>

export type ResetPasswordCompleteResponse = Readonly<{
    authenticationResult: AuthenticationCompleteResult
    authentication: Authentication
    user: AuthenticationUser
}>

export function isAuthenticationComplete(response: AuthenticationResponse): response is AuthenticationCompleteResponse {
    return response.authenticationResult.action === AuthenticationAction.AUTHENTICATION_COMPLETE
}

export function isCreatePassword(response: RequiresCreatePasswordResponse): response is RequiresCreatePasswordResponse {
    return response.authenticationResult.action === AuthenticationAction.CREATE_PASSWORD
}


export type AuthenticationResponse =
    | RequiresPasswordResponse
    | AuthenticationCompleteResponse
    | RequiresActivationCodeResponse
    | RequiresCreatePasswordResponse



export enum LoginStatus {
    AUTHENTICATING = "AUTHENTICATING",
    LOGGED_IN = "LOGGED_IN",
}

type AuthenticatingState = Readonly<{
    status: LoginStatus.AUTHENTICATING
    username: string | undefined
    rememberMe: boolean
}>

type LoggedInState = Readonly<{
    status: LoginStatus.LOGGED_IN
    user: AuthenticationUser
    authToken: string
}>

export type LoginState = AuthenticatingState | LoggedInState
